// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonMessage-module_styledSvg__TUUh_ {
    fill: var(--button-message-bg);
}

.buttonMessage-module_corner__cXbjJ {
    display: inline-flex;
    position: absolute;
    right: -10px;
    bottom: -4px;
}

.buttonMessage-module_messageButton__pKdXL {
    background: var(--button-message-bg);
    cursor: pointer;
    border: none;
    padding: 8px 24px;
    border-radius: 76px;
    box-sizing: border-box;
    display: inline-block;
    outline: none;
    position: relative;

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            background: var(--button-message-bg-hovered);

            .buttonMessage-module_styledSvg__TUUh_ {
                fill: var(--button-message-bg-hovered);
            }
        }
    }

    &:active,
    &:focus-visible {
        background: var(--button-message-bg-pressed);

        .buttonMessage-module_styledSvg__TUUh_ {
            fill: var(--button-message-bg-pressed);
        }
    }
}

.buttonMessage-module_messageButtonDisabled__MRjVG {
    pointer-events: none;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Buttons/styles/buttonMessage.module.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,aAAa;IACb,kBAAkB;;IAElB;QACI;YACI,4CAA4C;;YAE5C;gBACI,sCAAsC;YAC1C;QACJ;IACJ;;IAEA;;QAEI,4CAA4C;;QAE5C;YACI,sCAAsC;QAC1C;IACJ;AACJ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB","sourcesContent":[".styledSvg {\n    fill: var(--button-message-bg);\n}\n\n.corner {\n    display: inline-flex;\n    position: absolute;\n    right: -10px;\n    bottom: -4px;\n}\n\n.messageButton {\n    background: var(--button-message-bg);\n    cursor: pointer;\n    border: none;\n    padding: 8px 24px;\n    border-radius: 76px;\n    box-sizing: border-box;\n    display: inline-block;\n    outline: none;\n    position: relative;\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            background: var(--button-message-bg-hovered);\n\n            .styledSvg {\n                fill: var(--button-message-bg-hovered);\n            }\n        }\n    }\n\n    &:active,\n    &:focus-visible {\n        background: var(--button-message-bg-pressed);\n\n        .styledSvg {\n            fill: var(--button-message-bg-pressed);\n        }\n    }\n}\n\n.messageButtonDisabled {\n    pointer-events: none;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"styledSvg": `buttonMessage-module_styledSvg__TUUh_`,
	"corner": `buttonMessage-module_corner__cXbjJ`,
	"messageButton": `buttonMessage-module_messageButton__pKdXL`,
	"messageButtonDisabled": `buttonMessage-module_messageButtonDisabled__MRjVG`
};
export default ___CSS_LOADER_EXPORT___;
